import { render, staticRenderFns } from "./ClubSettings.vue?vue&type=template&id=0b15ab1c&scoped=true&"
import script from "./ClubSettings.vue?vue&type=script&lang=js&"
export * from "./ClubSettings.vue?vue&type=script&lang=js&"
import style0 from "./ClubSettings.vue?vue&type=style&index=0&id=0b15ab1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15ab1c",
  null
  
)

export default component.exports